<template>
    <div class="gamewrap">
        <template v-show="isFoodLoad&&isAnimalModelLoaded||!isTenSecond&&isTenSecond">
            <div class="noresult">
                <div class="gameTop">
                    <div class="container">
                        <div class="line1">
                            <img class="love" src="../assets/img/love.png" alt="">
                            <span class="num">X{{count}}</span>
                            <div class="numberlove_bj">
                                <img class="numberlove" :style="{width:count>=10?'98%':count*10+1+'%'}" src="../assets/img/numberlove.png" alt=""> 
                            </div>
                            <img @click="gamePause();" class="pause" src="../../static/img/stop.png" alt="">
                        </div>
                        <div class="line2">
                            <div><img class="headPic" :src="actAnimal.headImg" alt=""></div>
                            <div class="name_bj">
                                <div class="name">{{actAnimal.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="logo"></div>
            <!-- 黑色半透明背景 -->
            <div v-show="isTipsShow||isArrowShow||isReadyShow||isGoShow||isPauseShow||isGameOver" class="overlay">
            </div>
            <!-- 提示弹窗 -->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div v-if="isTipsShow" class="tips">
                    <div class="tips_font">
                        <template v-if="sessionStorage.isWebKit=='1'">
                            {{$t('loading.tipsText1')}}
                        </template>
                        <template v-else>
                            {{$t('loading.tipsText0')}}
                        </template>
                        <div class="tips_icon" @click="showArrow();"></div>
                    </div>
                </div>
            </transition>  
            <!-- 提示弹窗2 -->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div v-if="isArrowShow" :class="[sessionStorage.isWebKit=='1'?'arrow_phone':'arrow_tap']">
                    <div class="arrow_left"></div>
                    <div class="arrow_right"></div>
                    <div v-if="sessionStorage.isWebKit=='1'" class="arrow_top"></div>            
                </div>
            </transition>
            <!-- ready弹窗 -->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div v-if="isReadyShow" class="readyImg"></div>
            </transition>
            <!-- go弹窗 -->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div v-if="isGoShow" class="goImg"></div>
            </transition>
            <!-- 暂停 -->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div v-if="isPauseShow" class="pauseBox">
                    <div class="pause_btn">
                        <div class="btn_continue" @click="isPauseShow=false;gameBegin()"></div>
                        <div class="btn_exit" @click="resume();"></div>
                    </div>
                </div>
            </transition>
            <!-- 相机背景 -->
            <video id="videoBg" autoplay="true" muted playsinline style="object-fit: cover;position: fixed;top:0;left: 0;z-index: -1000;"></video>
            <!-- 3D场景 -->
            <a-scene id="senceMod" cursor="rayOrigin: mouse" vr-mode-ui="enabled: false">
                <a-assets>
                    <!-- <img id="texture" :src="$modelUrl+'/static/gif/lion.gif'"> -->
                    <img id="texture1" :src="$modelUrl+'/static/gif/lion1.png'">
                    <img id="texture2" :src="$modelUrl+'/static/gif/lion2.png'">
                </a-assets>
                <template v-for="(paopao,index) in paopaos">
                    <a-entity
                        v-show="paopao.isShow=='true'"
                        :key="index" :position="paopao.positionX+' '+paopao.positionY+' '+paopao.positionZ"
                        :visible="paopao.isShow"
                        scale="0.3 0.3 0.3"
                        geometry="primitive: sphere"
                        @click="entityClick(index)"
                        ref="paopaoGroups"
                        material="color:#fff;opacity:0.2"
                    >
                        <a-entity scale="0.09 0.09 0.09"  :fbx-model="'src:url('+paopao.url+')'" @model-loaded="paopaoLoad();"></a-entity>
                    </a-entity>
                </template>
                <a-entity id='cameraWrapper' position="0 0 0"><!-- :near="nearnum" -->
                    <a-camera visible="true" position="0 1.6 0" look-controls wasd-controls>
                        <a-image id="animalImg" width="1.19" height="0.8" scale="1.5 1.5 1.5" position="0.22 -0.98 -2.0" :src="isChange == 1?'#texture1':'#texture2'"></a-image>
                    </a-camera>
                </a-entity>

                <!-- <a-entity visible="true" id="camera" position="0 1.6 0" camera="zoom: 1" look-controls wasd-controls>
                    <a-image id="animalImg" width="1.2" height="1.2" scale="1.5 1.5 1.5" position="0.42 -1.12 -2.0" :src="isChange == 1?'#texture1':'#texture2'"></a-image>
                    <a-entity id="animal" position="-0.3 -0.9 -1.2" scale="0.02 0.02 0.02" rotation="0 70 0" :fbx-model="'src:url('+actAnimal.modelUrl+')'"></a-entity>
                </a-entity> -->
                <a-light type="point" color="#fff" position="0 5 0"></a-light>
                <a-light type="ambient" color="#fff"></a-light>
            </a-scene> 
            <!--游戏结束弹窗-->
            <transition
                name="fade"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
            >
                <div class="bulletWindow" v-show="isGameOver">
                    <div id="resultBox">
                        <template v-if="$i18n.locale=='zh'">
                            <img class="resultImg" :src="$modelUrl+'/static/img/result/lion_zh.png'" alt="">
                        </template>
                        <template v-else-if="$i18n.locale=='hk'">
                            <img class="resultImg" :src="$modelUrl+'/static/img/result/lion_fan.png'" alt="">
                        </template>
                        <template v-else-if="$i18n.locale=='en'">
                            <img class="resultImg" :src="$modelUrl+'/static/img/result/lion_en.png'" alt="">
                        </template>
                        <img class="closeBtn" @click="toResult()" src="../assets/img/close.png" alt="">
                    </div>
                    <!-- <div class="saveBtn" @click="setImage()">{{$t('game.saveBtn')}}</div> -->
                    <div class="pressFont">{{$t('game.press')}}</div>
                </div>
            </transition>  
        </template>
        <!-- 加载进度条 -->
        <div class="loadingBox" v-if="!isFoodLoad||!isAnimalModelLoaded||!isTenSecond">
            <Loading></Loading>
        </div>
        <!-- 泡泡gif -->
        <div class="gifBox" v-if="isShowGif" :style="{left:clickX+'px',top:clickY+'px',zIndex:50}">
            <img :src="$modelUrl+'/static/gif/2.gif?time='+clickCount" alt="">
        </div>
        <!-- 增加gif -->
        <div class="gifBox" v-if="isShowGif"  :style="{left:clickX+'px',top:clickY+'px',zIndex:50}">
            <img :src="$modelUrl+'/static/gif/add.gif?time='+clickCount" alt="">
        </div>
        <!-- 减少gif -->
        <div class="gifBox" v-if="isShowSubGif" :style="{left:clickX+'px',top:clickY+'px',zIndex:50}">
            <img :src="$modelUrl+'/static/gif/sub.gif?time='+clickCount" alt="">
        </div>
        <!-- 增加爱心gif -->
        <div v-if="isShowGif" class="addLoveBox">
            <img :src="$modelUrl+'/static/gif/addlove.gif?time='+clickCount" alt="">
        </div>
        <!-- 增加好感gif -->
        <div v-if="isShowGif" class="addAnimalBox">
            <img :src="$modelUrl+'/static/gif/loves.gif?time='+clickCount" alt="">
        </div>
        <div class="bg"></div>
    </div>
</template>

<script>
import Loading from '@/components/Loading'
import html2canvas from 'html2canvas'
export default {
    components: {
        Loading,
    },
    data(){
        return{
            isTenSecond:false,
            isFoodLoad:false,
            foodLoadNum:0,
            isAnimalModelLoaded:false,
            isGameOver:false,
            animal:{},
            count:0,
            paoCount:18,
            showCount:6,
            actAnimal:{
                type:'meat',
                name:this.$t('animals.lion'),
                headImg:this.$modelUrl+'/static/img/head/Badges_lion.png',
                modelUrl:this.$modelUrl+'/static/model/animal/LION.fbx',
            },
            isChange:0,
            paopaos:[

            ],
            foods:[
                {
                    type:'meat',
                    url:this.$modelUrl+'/static/model/foods/RO_2.fbx'
                },
                {
                    type:'gress',
                    url:this.$modelUrl+'/static/model/foods/shiwu.fbx'
                },
                {
                    type:'other',
                    url:this.$modelUrl+'/static/model/foods/tang_3.fbx'
                },
            ],
            musics:[
                this.$modelUrl+'/static/music/BGM.mp3',
                this.$modelUrl+'/static/music/ready.mp3',
                this.$modelUrl+'/static/music/right.mp3',
                this.$modelUrl+'/static/music/wrong.mp3',
                this.$modelUrl+'/static/music/result.mp3'
            ],
            bgm:{},
            readyMusic:{},
            rightMusic:{},
            resultMusic:{},
            wrongMusic:{},
            isBegin:false,
            timer:{},
            initTimer:{},
            isTipsShow:true,
            isArrowShow:false,
            isReadyShow:false,
            isGoShow:false,
            isPauseShow:false,
            clickX:0,
            clickY:0,
            isGetCode:false,
            isShowGif:false,
            isShowSubGif:false,
            clickCount:0,
            nearnum:0.005,
        }
    },
    mounted(){
        this.aframeInit();
        const that=this;
        window.addEventListener('touchstart',function(e){
            if(!that.isShowGif){
                that.clickX=e.targetTouches[0].clientX;
                that.clickY=e.targetTouches[0].clientY;
            }
        });//添加监听
        setTimeout(function(){
            that.isTenSecond=true;
            that.videoBgInit();
        },8000);
        this.musicPlayerInit();
        
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
            that.nearnum = 0.005;
        } else {
            that.nearnum = 0.001;
        }
    },
    beforeDestroy(){
    },
    methods:{
        videoBgInit(){
            var aVideo = document.getElementById('videoBg');
            aVideo.style.width='100vm';
            aVideo.style.height='100vh';

            // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }

            // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia 
            // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function(constraints) {
                    // 首先，如果有getUserMedia的话，就获得它
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                    // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                    }

                    // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                }
            }

            navigator.mediaDevices.getUserMedia({
                video:{
                    facingMode: { exact: "environment" } //使用后置摄像头
                    // facingMode: { exact: "user" } //使用前置摄像头
                },
                audio:false
            })
            .then(function(stream) {
                /* 使用这个stream stream */
                console.log('已点击允许,开启成功');
                // console.log(stream);
                aVideo.srcObject = stream;
            })
            .catch(function(err) {
                console.log(err);
                aVideo.style.display="none";
                alert('当前浏览器无法获取相机!!!');
            });

            window.onresize = function(){
                aVideo.style.width=document.body.clientWidth+'px';
                aVideo.style.height=document.body.clientHeight+'px';
            }
        },
        aframeInit(){
            var vm=this;
            var preIndex;
            for(var i=0;i<vm.paoCount;i++){
                var newpaopao={};
                var urlIndex=Math.floor(Math.random()*3);
                if(preIndex==urlIndex){
                    if(urlIndex==2){
                        urlIndex=0;
                    }else{
                        urlIndex+=1;
                    }
                }
                preIndex=urlIndex;
                newpaopao.url=vm.foods[urlIndex].url;
                newpaopao.type=vm.foods[urlIndex].type;
                newpaopao.positionX=Math.random()*4-2;
                newpaopao.positionY=4+i*0.7;
                newpaopao.positionZ=Math.sqrt(4-newpaopao.positionX*newpaopao.positionX);
                newpaopao.positionZ=Math.round(Math.random())==0?-(newpaopao.positionZ):newpaopao.positionZ;
                newpaopao.isShow='false';
                if(i<vm.showCount){
                    newpaopao.isShow='true';
                }
                vm.paopaos.push(newpaopao);

                var cpPaopao = JSON.parse(JSON.stringify(newpaopao)); //复制一个泡泡在x轴相反的位置
                cpPaopao.positionX=-(cpPaopao.positionX);
                cpPaopao.positionZ=-(cpPaopao.positionZ);
                vm.paopaos.push(cpPaopao);
            }
            // document.getElementById('animal').addEventListener("model-loaded",function(){
            //     console.log('model-loaded');
            //     vm.isAnimalModelLoaded=true;
            // });
            vm.isAnimalModelLoaded=true;
            vm.showCount=vm.showCount*2;
            // AFRAME.registerComponent('webar', {
            //     init:function(){
            //     },
            // });
        },
        musicPlayerInit(){
            this.bgm=new Audio();
            this.bgm.src=this.musics[0];
            this.bgm.loop=true;
            this.bgm.preload='auto';

            this.readyMusic=new Audio();
            this.readyMusic.src=this.musics[1];
            this.readyMusic.preload='auto';

            this.rightMusic=new Audio();
            this.rightMusic.src=this.musics[2];
            this.rightMusic.preload='auto';

            this.wrongMusic=new Audio();
            this.wrongMusic.src=this.musics[3];
            this.wrongMusic.preload='auto';

            this.resultMusic=new Audio();
            this.resultMusic.src=this.musics[4];
            this.resultMusic.preload='auto';
        },
        gameBegin(){
            console.log('gameBegin');
            this.isBegin=true;
            this.bgm.play();
            var vm=this;
            this.initTimer=window.setInterval(function(){
                if(vm.showCount>=vm.paoCount*2){
                    window.clearInterval(vm.initTimer);
                }else{
                    for(var i=vm.showCount;i<vm.paopaos.length;i++){
                        if(vm.paopaos[i].isShow=='false'){
                            vm.showCount++;
                            var temp=vm.paopaos[i];
                            temp.isShow='true';
                            vm.$set(vm.paopaos,i,temp);
                            break;
                        }
                    }
                }
            },500);
            this.timer=window.setInterval(function(){
                for(let i=0;i<vm.paopaos.length;i++){
                    var temp=vm.paopaos[i];
                    vm.paopaos[i].positionY-=0.03;
                    if(temp.positionY<=-1){
                        temp.positionY=11.6;
                        temp.isShow='true';
                    }
                    vm.$set(vm.paopaos,i,temp);
                }
            },30);
        },
        gamePause(){
            console.log('gamePause');
            this.isBegin=false;
            this.bgm.pause();
            this.isPauseShow=true;
            window.clearInterval(this.timer);
            window.clearInterval(this.initTimer);
        },
        entityClick(index){
            var temp=this.paopaos[index];
            // 判断点击的食物是不是对的。
            if(temp.isShow=='true'){
                this.clickCount++;
                if(temp.type==this.actAnimal.type){
                    this.count++;
                    temp.isShow='false';
                    this.$set(this.paopaos,index,temp);
                    this.isShowGif=true;
                    this.isGetCode=true;
                    const that=this;
                    setTimeout(function(){
                        that.isShowGif=false;
                    },701);
                    this.animalAnimate(1);
                    if(this.count>=10){
                        this.isGameOver=true;
                        this.gamePause();
                        this.playTip(4);
                        this.bgm.pause();
                    }else{
                        this.playTip(2);
                    }
                }else{
                    if(this.count>0){
                        this.count--;
                    }
                    this.paoPaoAnimate(index);
                    this.playTip(3);
                    this.isShowSubGif=true;
                    const that=this;
                    setTimeout(function(){
                        that.isShowSubGif=false;
                    },601);
                    this.animalAnimate(2);
                }
            }

        },
        animalAnimate(status){
            var self = this;
            // var animal=document.getElementById('animal');
            self.isChange = status;
            if(status == 1){
                setTimeout(function(){
                    self.isChange = 0;
                },900);
            }else{
                var animal=document.getElementById('animalImg');
                animal.setAttribute('animation', {
                    property: 'scale',
                    to: '1.49 1.49 1.49',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
                setTimeout(function(){
                    animal.setAttribute('animation', {
                        property: 'scale',
                        to: '1.5 1.5 1.5',
                        easing: 'easeOutElastic',
                        dur: 150,
                    })
                },150);
                setTimeout(function(){
                    animal.setAttribute('animation', {
                        property: 'scale',
                        to: '1.49 1.49 1.49',
                        easing: 'easeOutElastic',
                        dur: 150,
                    })
                },300);
                setTimeout(function(){
                    animal.setAttribute('animation', {
                        property: 'scale',
                        to: '1.5 1.5 1.5',
                        easing: 'easeOutElastic',
                        dur: 150,
                    })
                },450);
                setTimeout(function(){
                    animal.setAttribute('animation', {
                        property: 'scale',
                        to: '1.49 1.49 1.49',
                        easing: 'easeOutElastic',
                        dur: 150,
                    })
                },600);
                setTimeout(function(){
                    animal.setAttribute('animation', {
                        property: 'scale',
                        to: '1.5 1.5 1.5',
                        easing: 'easeOutElastic',
                        dur: 150,
                    })
                },750);
                setTimeout(function(){
                    self.isChange = 0;
                    animal.removeAttribute('animation');
                },900);
            }
        },
        paoPaoAnimate(index){
            var paopao=this.$refs.paopaoGroups[index];
            paopao.setAttribute('animation', {
                property: 'scale',
                to: '0.3 0.3 0.3',
                easing: 'easeOutElastic',
                dur: 150,
            })
            setTimeout(function(){
                paopao.setAttribute('animation', {
                    property: 'scale',
                    to: '0.28 0.28 0.28',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
            },150);
            setTimeout(function(){
                paopao.setAttribute('animation', {
                    property: 'scale',
                    to: '0.3 0.3 0.3',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
            },300);
            setTimeout(function(){
                paopao.setAttribute('animation', {
                    property: 'scale',
                    to: '0.28 0.28 0.28',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
            },450);
            setTimeout(function(){
                paopao.setAttribute('animation', {
                    property: 'scale',
                    to: '0.3 0.3 0.3',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
            },600);
            setTimeout(function(){
                paopao.setAttribute('animation', {
                    property: 'scale',
                    to: '0.28 0.28 0.28',
                    easing: 'easeOutElastic',
                    dur: 150,
                })
            },750);
            setTimeout(function(){
                paopao.removeAttribute('animation');
            },900);
        },
        showArrow(){
            this.isTipsShow=false;
            this.isArrowShow=true;
            var vm=this;
            setTimeout(function(){
                vm.isArrowShow=false;
                vm.isReadyShow=true;
                vm.playTip(1);
                setTimeout(function(){
                    vm.isReadyShow=false;
                    vm.isGoShow=true;
                    setTimeout(function(){
                        vm.isGoShow=false;
                        vm.gameBegin();
                    },1500);
                },1000);
            },1000);
        },
        resume(){
            window.location.reload();
        },
        toResult(){
            this.$router.push('/Success')
        },
        playTip(index){
            // 1 2 3 4
            switch (index) {
                case 1:
                    this.readyMusic.currentTime =0;
                    this.readyMusic.play();
                    break;
                case 2:
                    this.rightMusic.currentTime =0;
                    this.rightMusic.play();
                    break;
                case 3:
                    this.wrongMusic.currentTime =0;
                    this.wrongMusic.play();
                    break;
                case 4:
                    this.resultMusic.currentTime =0;
                    this.resultMusic.play();
                    break;
                default:
                    // statements_def
                    break;
            }
        },
        paopaoLoad(){
            this.foodLoadNum++;
            if(this.foodLoadNum>=this.paoCount*2){
                this.isFoodLoad=true;
            }
            console.log(this.foodLoadNum);
        },
        setImage() {//canvas生成图片来着，不兼容放弃了。
            let that = this;
            event.preventDefault();
            var canvas2 = document.createElement("canvas");
            let _canvas = document.getElementById('resultBox');
            var w = parseInt(window.getComputedStyle(_canvas).width);
            var h = parseInt(window.getComputedStyle(_canvas).height);
            //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了  
            canvas2.width = w * 2;
            canvas2.height = h * 2;
            canvas2.style.width = w + "px";
            canvas2.style.height = h + "px";
            //可以按照自己的需求，对context的参数修改,translate指的是偏移量  
            //  var context = canvas.getContext("2d");  
            //  context.translate(0,0);  
            var context = canvas2.getContext("2d");
            context.scale(1, 1);
            html2canvas(document.getElementById('resultBox'), {
                canvas: canvas2
            }).then(function (canvas) {
                var blob = that.getBlob(canvas);
                // console.log(blob);
                var reader = new FileReader();
                reader.readAsDataURL(blob); 
                reader.onload = function (e) {
                    var a = document.createElement('a');   // 转换完成，创建一个a标签用于下载
                    a.download = that.actAnimal.name+'.png';
                    a.href = e.target.result;
                    $("body").append(a);    // 修复firefox中无法触发click
                    a.click();
                    $(a).remove();
                }
            });
        },
        getBlob(canvas) { //获取blob对象
            var data = canvas.toDataURL("image/png", 1);
            data = data.split(',')[1];
            data = window.atob(data);
            var ia = new Uint8Array(data.length);
            for (var i = 0; i < data.length; i++) {
                ia[i] = data.charCodeAt(i);
            }
            return new Blob([ia], {
                type: "image/jpeg"
            });
        },
    }
}
</script>

<style scoped>
    .gamewrap{  
        height: 100%;
    }
    .gameTop{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height:247px; 
        background: url('../assets/img/game_page.png') no-repeat;
        background-size: cover;
    }
    .container{
        width: 720px;
        height: 227px;
        margin: 0 auto;
    }
    .line1{
        height: 70px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        margin-top: 20px;
    }
    .line1 .love{
        width: 64px;
        height: 56px;
        margin-left: 52px;
    }
    .num{
        width: 60px;
        height: 30px;
        line-height: 30px;
        font-size: 26px;
        color: #fff;
        margin:0 5px;
    }
    
    /*第一行样式*/
    .numberlove_bj{
        flex: auto 0;
        width: 450px;
        height: 32px;
        border-radius: 16px;
        background: url('../assets/img/numberlove_bj.png') no-repeat ;
        background-size: cover;
        position: relative;
        display: inline-block;
        overflow: hidden;
    }
    .numberlove{
       position: absolute;
       height: 22px;
       border-radius: 11px;
       top: 5px;
       left: 4px;
    }

    /*第二行*/
    .line2{
        display: flex;
    }
    .headPic{
        width: 110px;
        height: 110px;
        margin-top: 14px;
        margin-left: 35px;
        border-radius: 50%;
    }
    .name_bj{
        float: right;
        width: 510px;
        height: 90px;
        background: url('../assets/img/game_name.png') no-repeat ;
        background-size: cover;
        margin-top:36px;
        margin-left: 40px;
    }
    .name_bj .name{
        color: #fff;
        font-size: 40px;
        line-height: 90px;
        text-align: center;
    }

    /*弹窗*/
    .bulletWindow{
        background-color: rgba(0, 0, 0, .8);
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 50;
    }
    /*弹窗背景图*/
    .save_page_bj{
        width: 586px;
        height: 748px;
        background: url('../assets/img/save_page_bj.png') no-repeat;
        background-size: cover;
        margin-top: 100px;
        position: relative;
    }

    .resultDiploma{
        width: 348px;
        height: 284px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -129px;
    }
    /*关闭弹窗按钮*/
    .closeBtn{
        width: 60px;
        height: 60px;
        position: absolute;
        top: 0px;
        right: -5px;
    }
    .resultText{
        color: #fff;
        font-size: 35px;
        padding-top: 154px;
        padding-left: 37px;
        padding-right: 37px;
        text-align: center;
    }
    /*放动物头像的背景样式*/
    .resultHead{
        width: 306px;
        height: 307px;
        display: inline-block;
        margin-top: 18px;
        margin-left: 136px;
    }
    .animalName{
        color: #AA723C;
        font-size: 70px;
        text-align: center;
    }
    /*保存按钮*/
    .saveBtn{
        width: 240px;
        height: 90px;
        background: url('../assets/img/button.png') no-repeat;
        background-size: cover;
        margin-top: 20px;
        margin-left: 240px;
        color: #fff;
        font-size: 48px;
        text-align: center;
        line-height: 90px;
    }
    .loadingBox{
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #fff;
        top: 0;
        left: 0;
        z-index: 1000;
    }
    
    .overlay{
        width: 100%;
        height: 100vh;
        z-index: 19;
        position: fixed;
        background: #000;
        opacity: 0.3;
        top: 0;
        left: 0;
    }
    .tips{
        width:90%;
        height: 420px;
        position: fixed;
        top: 50%;
        z-index: 25;
        margin-top: -160px;
        margin-left: 5%;
        background: url('../../static/img/tips1.png') no-repeat;
        background-size: auto 100%;
        background-position: center;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;    
        justify-content: center;
        align-items: center;
    }
    .tips_font{
        width: 520px;
        height: 180px;
        color: #a4794c;
        font-size: 32px;
        text-align: center;
        position: relative;
    }
    .tips_icon{
        position: absolute;
        bottom: -90px;
        left:50%;
        margin-left: -140px; 
        width: 280px;
        height: 112px;
        background: url('../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
    }
    .arrow_phone{
        width: 140px;
        height: 260px;
        background: url('../../static/img/arrow/phone.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        z-index: 25;
        left: 50%;
        top: 50%;
        margin-top: -130px;
        margin-left: -70px;
    }
    .arrow_tap{
        width: 140px;
        height: 260px;
        background: url('../../static/img/arrow/dj.png') no-repeat;
        background-size: 100% 100%;
        position: relative;
        z-index: 25;
        left: 50%;
        top: 50%;
        margin-top: -130px;
        margin-left: -70px;
    }
    .arrow_left{
        background: url('../../static/img/arrow/arrow_left.png') no-repeat;
        background-size: 100% 100%;
        width: 200px;
        height: 80px;
        position: absolute;
        top: 50%;
        margin-top: -40px;
        left: -240px;
    }
    .arrow_right{
        background: url('../../static/img/arrow/arrow_right.png') no-repeat;
        background-size: 100% 100%;
        width: 200px;
        height: 80px;
        position: absolute;
        top: 50%;
        margin-top: -40px;
        right: -240px;
    }
    .arrow_top{
        background: url('../../static/img/arrow/arrow_up.png') no-repeat;
        background-size: 100% 100%;
        width: 80px;
        height: 200px;
        position: absolute;
        left: 50%;
        margin-left: -40px;
        top: -240px;
    }
    .readyImg{
        width: 500px;
        height:200px;
        position: fixed;
        z-index: 25;
        left: 50%;
        top: 50%;
        margin-left: -250px;
        margin-top: -100px;
        background: url('../../static/img/ready.png') no-repeat;
        background-size: 100% 100%;
    }
    .goImg{
        width: 260px;
        height: 160px;
        position: fixed;
        z-index: 25;
        left: 50%;
        top: 50%;
        margin-left: -130px;
        margin-top: -80px;
        background: url('../../static/img/go.png') no-repeat;
        background-size: 100% 100%;
    }
    .pause{
        width: 55px;
        height: 55px;
        margin-left: 5px;
        margin-right: 20px;
    }
    .pauseBox{
        width: 500px;
        height: 160px;
        position: fixed;
        z-index: 25;
        top: 50%;
        left: 50%;
        margin-left: -250px;
        margin-top: -80px;
        background: url('../../static/img/stop_bj.png') no-repeat;
        background-size: 100% 100%;
    }
    .pause_btn{
        width: 100%;
        height: 160px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-around;
        align-items: center;
    }
    .btn_continue{
        width: 150px;
        height: 90px;
        background: url('../../static/img/play.png') no-repeat;
        background-size: 100% 100%;
    }
    .btn_exit{
        width: 150px;
        height: 90px;
        background: url('../../static/img/repaly.png') no-repeat;
        background-size: 100% 100%;
    }
    .gifBox{
        width: 360px;
        height: 360px;
        margin-left: -180px;
        margin-top: -180px;
        position: fixed;
    }
    .gifBox>img{
        width: 360px;
        height: 360px;
    }
    .addLoveBox{
        width: 200px;
        height: 200px;
        position: fixed;
        left: -15px;
        top: -45px;
        z-index: 50;
    }
    .addLoveBox>img{
        width: 200px;
        height: 200px;
    }
    .addAnimalBox{
        width: 50%;
        height: auto;
        position: fixed;
        /*left: 0;*/
        /*bottom: 20px;*/
        right: 0;
        bottom: 40px;
        z-index: 50;
    }
    .addAnimalBox>img{
        width: 100%;
        height: auto;
    }
    #resultBox{
        width: 586px;
        height: 880px;
        margin: 50px auto 0;  
        display: flex;
        display: -webkit-flex;
        align-items:flex-end;
        position: relative;
    }
    .resultImg{
        width: 100%;
        height: auto;
    }
    .pressFont{
        width: 586px;
        margin: 5px auto 0; 
        word-break: keep-all;
        font-size: 32px;
        line-height: 40px;
        text-align: center;
        color: #AA723C;   
    }
    /* 进入前和结束后的状态 */
    .v-enter,.v-leave-to{
        opacity: 0;
        transform: translateX(80px);
    }
    /* 进入和离开的动画时间段 */
    .v-enter-active,.v-leave-active{
        
        transition: all 0.5S ease
    }
    .logo{
        width: 180px;
        height: 120px;
        position: fixed;
        /*right: 20px;*/
        left: 20px;
        bottom: 20px;
        background: url('../assets/img/logo.png') no-repeat;
        background-size: 100% 100%;
    }
    .bg{
        position: fixed;
        z-index: -1100;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: url('../assets/img/result_bj.png') no-repeat ;
        background-size: cover;
        background-position: center;
    }
    .lion{
        position: fixed;
        z-index: 45;
        /*bottom: 40px;
        left: -20%;*/
        bottom: -40px;
        right: -20%;
        width: 100%;
        height: auto;
        z-index: 2;
    }
    .lion>img{
        width: 100%;
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Game.vue